import { accessEntries } from "@/mocks/home";

export default function AccessSection() {
  return (
    <section id="access" className="border-t border-background-200 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
              多端入口
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              51视频 的四种访问方式
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              不同设备适合不同入口。电脑端适合网页版，手机端推荐安装 App，
              客厅电视用大屏版本，而收藏本页则是所有入口的总目录。
            </p>
          </div>
          <a
            href="#guide"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看完整使用指南
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {accessEntries.map((entry) => (
            <article
              key={entry.title}
              className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${entry.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-lg text-foreground-950">{entry.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{entry.desc}</p>
              <div className="mt-4 flex items-start gap-2 rounded-lg bg-secondary-100 px-3 py-2.5">
                <i className="ri-route-line mt-0.5 text-sm text-secondary-700" aria-hidden="true"></i>
                <p className="text-xs leading-relaxed text-foreground-700">{entry.method}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}